import { Box, Typography, Stack, Container } from "@mui/material";
import { useTheme } from "@mui/material/styles";

import * as React from "react";
import { Link, Outlet, useLocation } from "react-router-dom";
import useResponsive from "../../hooks/useResponsive";
import { PATH_AUTH } from "../../routes/path";

const AuthLayout: React.FC = () => {
  const theme = useTheme();
  const isMedium = useResponsive("down", "md", "xs");
  const isSmall = useResponsive("down", "sm", "xs");
  const location = useLocation();

  return (
    <Box
      sx={{
        position: "relative",
        width: "100%",
        backgroundColor: theme.palette.common.white,
        display: "flex",
        justifyContent: "space-between",
      }}
    >
      <IconBg />
      <Box
        sx={{
          width: isSmall ? "95%" : isMedium ? "80%" : "55%",
          marginX: "auto",
          height: "100vh",
          overflowY: "auto",
        }}
      >
        <Box
          sx={{
            width: isSmall ? "100%" : "75%",
            marginX: "auto",
            height: "90%",
            py: 4,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <Box
            sx={{
              display: "flex",
              justifyContent: "flex-end",
              width: "100%",
            }}
          >
            {location.pathname === "/auth/sign-up" && (
              <Typography
                variant="caption"
                sx={{
                  color: theme.palette.secondary.contrastText,
                }}
              >
                Already have an account?
                <Link
                  to={PATH_AUTH.signIn}
                  style={{
                    color: "#459173",
                    fontWeight: 600,
                    fontSize: 13,
                    fontFamily: "Poppins",
                    padding: "5px",
                    textDecorationLine: "none",
                  }}
                >
                  Login
                </Link>
              </Typography>
            )}
            {location.pathname === "/auth/sign-in" && (
              <Typography
                variant="caption"
                sx={{
                  color: theme.palette.secondary.contrastText,
                }}
              >
                Don’t have an account?
                <Link
                  to={PATH_AUTH.signUp}
                  style={{
                    color: "#459173",
                    fontWeight: 600,
                    fontSize: 13,
                    fontFamily: "Poppins",
                    padding: "5px",
                    textDecorationLine: "none",
                  }}
                >
                  Register
                </Link>
              </Typography>
            )}
          </Box>
          <Outlet />
        </Box>
      </Box>
    </Box>
  );
};
export default AuthLayout;

const IconBg = () => {
  const isMedium = useResponsive("down", "md", "xs");
  const theme = useTheme();
  return (
    <Box
      sx={{
        display: isMedium ? "none" : "block",
        width: isMedium ? "0px" : "45%",
        height: "96vh",
        marginY: "auto",
        marginX: 3,
        position: "relative",
      }}
    >
      <Box
        sx={{
          width: "100%",
          height: "100%",
          backgroundColor: theme.palette.primary.main,
          zIndex: 5,
          borderRadius: "20px",
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
        }}
      >
        <Box
          sx={{
            mt: 4,
            height: 150,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <img
            src="/assets/icons/icon-main.png"
            alt=""
            width={180}
            height={200}
          />
        </Box>
        <Box
          sx={{
            height: 60,
          }}
        />
        <Box
          sx={{
            mb: 10,
            px: 4,
          }}
        >
          <Stack>
            <Typography
              variant="h3"
              sx={{
                color: theme.palette.common.white,
                fontWeight: 900,
                fontFamily: "Satoshi",
                textAlign: "center",
              }}
            >
              Connect with Your Elected Representatives
            </Typography>
            <Typography
              variant="h5"
              sx={{
                color: theme.palette.common.white,
                fontWeight: 500,
                fontFamily: "Satoshi",
                textAlign: "center",
                width: "80%",
                mx: "auto",
              }}
            >
              Connect directly with your representatives and stay informed about their activities and legislative actions.
            </Typography>
          </Stack>
        </Box>
      </Box>
    </Box>
  );
};
